import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class JahresertragSolarstromanlage extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    mittlerer_ertrag: number | null = null;
    untere_grenze: number | null = null;
    obere_grenze: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'JahresertragSolarstromanlage';
    }
}

export async function createNewJahresertragSolarstromanlage(): Promise<JahresertragSolarstromanlage> {
    const model = createModel(JahresertragSolarstromanlage, {});

    await model.save();
    return model;
}

export class JahresertragSolarstromanlageCollection extends BaseCollection<JahresertragSolarstromanlage> {
    protected modelCls = JahresertragSolarstromanlage;

    public getModelClassName(): string {
        return 'JahresertragSolarstromanlage';
    }
}
